import { render, staticRenderFns } from "./grouponSetting.vue?vue&type=template&id=9283d0be&scoped=true&"
import script from "./grouponSetting.vue?vue&type=script&lang=js&"
export * from "./grouponSetting.vue?vue&type=script&lang=js&"
import style0 from "./grouponSetting.vue?vue&type=style&index=0&id=9283d0be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9283d0be",
  null
  
)

export default component.exports